import React from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import { teacher } from './../store/teacher'
import TeacherIntrument from '../block/TeacherInstument'
import { observer } from 'mobx-react-lite'

export default observer(function TeacherContainer() {
	const { t } = useTranslation()
	return (
		<div>
			<CenterContent>
				<TeacherIntrument />

				<div className='TableWrapper'>
					<table>
						<thead>
							<tr>
								<th style={{ width: '5%' }}>№</th>
								<th style={{ width: '65%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							</tr>
						</thead>
						<tbody>
							{teacher.teachers.map((item, index) => {
								if (item.id_teacher == teacher.teacher.id_teacher && item.post == teacher.teacher.post) {
									return (
										<tr
											key={index}
											className='active_line'
											onClick={() => {
												teacher.newTeacher(item)
											}}
										>
											<td>{index + 1}</td>
											<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
										</tr>
									)
								}
								return (
									<tr
										key={index}
										onClick={() => {
											teacher.newTeacher(item)
										}}
									>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			</CenterContent>
		</div>
	)
})
